import { OrderVideo } from "@/components/wizard/StepVideo";
import { ItemList, needsDesign } from "@/components/wizard/StepProducts";
import { StepNav } from "@/components/wizard/Stepper";

export const StepPreview = ({ order, go, back }) => (
  <div>
    <h2 className="text-3xl font-bold text-[#4A2A18]">Here's your keepsake</h2>
    <p className="mt-3 text-lg text-[#4A3B32]">Play your video and look over your items. Everything look right?</p>
    <div className="mt-10 grid gap-10 md:grid-cols-2 md:items-center">
      <OrderVideo order={order} />
      <div>
        <ItemList order={order} />
        {order.message && <p className="font-script mt-6 text-center text-2xl text-[#4A3B32]" data-testid="preview-message">"{order.message}"</p>}
      </div>
    </div>
    <div className="mt-8 flex flex-wrap justify-center gap-3">
      <button className="btn-outline" onClick={() => go(1)} data-testid="edit-video-button">Change video</button>
      <button className="btn-outline" onClick={() => go(2)} data-testid="edit-title-button">Edit title</button>
      <button className="btn-outline" onClick={() => go(3)} data-testid="edit-products-button">Change items</button>
      {needsDesign(order) && <button className="btn-outline" onClick={() => go(4)} data-testid="edit-sticker-button">Change design</button>}
    </div>
    <StepNav back={back} next={() => go(6)} nextLabel="Looks good!" />
  </div>
);
